var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-layout"},[_c('main',{staticClass:"mobile-layout__content",class:{'mobile-layout__content--with-tab': !_vm.$route.meta.hideMobileTabBar}},[_c('router-view')],1),(!_vm.$route.meta.hideMobileTabBar)?_c('mobile-tab-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }